import { Component } from '@angular/core';

@Component({
  selector: 'app-apagar-comunicacao-indevida',
  templateUrl: './apagar-comunicacao-indevida.component.html',
  styleUrls: ['./apagar-comunicacao-indevida.component.scss']
})
export class ApagarComunicacaoIndevidaComponent {}
